var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 71,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108 53.475a16.886 16.886 0 00-6.268-13.408A14.648 14.648 0 0194 46.9a14.656 14.656 0 00-6.63-27.652 9.237 9.237 0 00-1.468.077 33.319 33.319 0 012.75 12.392h-.219a34.642 34.642 0 00-68.842 0h-.228c.03-4.212.893-8.377 2.54-12.255-12.663 1.6-21.9 12.392-21.9 25.6a25.8 25.8 0 0025.685 25.919h65.324v-.026A17.417 17.417 0 00108 53.475z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.501 52a.5.5 0 01-.5-.5V39h-9.793a.5.5 0 01-.353-.855l16.793-16.791a.499.499 0 01.704 0l16.795 16.791a.5.5 0 01-.354.855h-9.792v12.5a.5.5 0 01-.5.5h-13z",
    fill: "#17BED0"
  })));
}
export default SvgCloudDrop;